export default "__VITE_ASSET__CAMh_wHD__"